import { Component, OnInit } from '@angular/core';
import { AuthenticationService,FormService,SurveyService, ProfileService, AlertService,CompanyService} from '../_services/index';
import {Router, ActivatedRoute} from "@angular/router";
import * as moment from 'moment';
@Component({
  selector: 'app-forms',
  templateUrl: './surveyList.component.html',
  styleUrls: ['./surveyList.component.scss']
})
export class SurveyListComponent implements OnInit {
  private authorized:any;
  public surveys:any;
  public param:any;
  public profile:any;
  public business:any;
  public a:any;
  public today = moment(new Date()).format('YYYY-MM-DD');
  constructor(
    public profileService: ProfileService,
    public surveyService:SurveyService,
    public companyService:CompanyService,
    public alertService:AlertService,
    private router: Router,
    public as: AuthenticationService,
    private route: ActivatedRoute,
  ) { 
    console.log(this.today)
    this.authorized = this.as.checkAuthentication();
      if(!this.authorized.authorized){
          this.router.navigate(['/login'])
      }
  }
  ngOnInit() {
    this.profileService.cast.subscribe(response => {
      this.profile = response;
      if(this.profile && this.profile.role.name == 'root' || this.profile && this.profile.role.name == 'super'){
        this.getCompany();
      }
    }, error => {
    })
    this.route.queryParams.subscribe(params => {
      this.a=JSON.stringify(params);
    });
    this.param = {
      startDate:this.today,
      endDate:this.today,
      page:JSON.parse(this.a).page?JSON.parse(this.a).page:1,
      offset:JSON.parse(this.a).offset?JSON.parse(this.a).offset:100,
      riskLevel:JSON.parse(this.a).lastName?JSON.parse(this.a).lastName:'Nulo',
      companyCode:JSON.parse(this.a).companyCode?JSON.parse(this.a).companyCode:'',
      where:'{"riskLevel":"'+(JSON.parse(this.a).riskLevel?JSON.parse(this.a).riskLevel:'Nulo').toString()+'","companyCode":"'+(JSON.parse(this.a).companyCode?JSON.parse(this.a).companyCode:'').toString()+'"}'
    }
    this.getSurveys(this.param);
    
  }
  getCompany(){
    this.companyService.getBussiness({page:1,offset:100,orderby:"[['name','ASC']]"}).subscribe(response => {
        this.business = response; 
    }, error => {
    })
  }
  changeFilter(data){
    this.param.where = '{"riskLevel":"'+data.riskLevel.toString()+'","companyCode":"'+data.companyCode.toString()+'"}',
    this.getSurveys(this.param);
  }
  url(path){
    this.router.navigate([path]);
  }
  alert(data){
    this.alertService.updateAlert(data).subscribe(()=>{
        setTimeout(() => {
        this.alertService.deleteAlert().subscribe();
        }, 8000);
    })
  }
  getSurveys(data){
    this.surveyService.getSurveyList(data).subscribe(response => {
      this.surveys = response
    }, error => {
    })
  }
  
}
